import { Component } from '@angular/core';
import { BasePageComponent } from '../base-page/base-page.component';

@Component({
  selector: 'app-dispatcher-page',
  templateUrl: './dispatcher-page.component.html',
  styleUrls: ['./dispatcher-page.component.scss'],
})
export class DispatcherPageComponent extends BasePageComponent {
  public override ngOnInit(): void {
    super.ngOnInit();
    this.router.navigateByUrl(this.routes.landing.url);
  }
}
